import React from "react";
import { QueryStatus } from "@sscs/types";
import { Callout, KeyValueList, QueryResult } from "@sscs/ui";
import { humanReadableBytes } from "@sscs/utils";
import styles from "./urlImportUsage.module.scss";

type UrlImportUsageProps = {
  queryStatus: QueryStatus;
  fileSize: number | null | undefined;
  hasSufficientCapacity: boolean;
  isOverSizeLimit: boolean;
  remainingAfterImport: number;
  remainingQuota: number;
  uploadLimit: number;
};

const UrlImportUsage = ({
  queryStatus,
  fileSize,
  hasSufficientCapacity,
  isOverSizeLimit,
  remainingAfterImport,
  remainingQuota,
  uploadLimit,
}: UrlImportUsageProps): React.JSX.Element => {
  return (
    <div>
      {queryStatus.status === "LOADING" && (
        <span>Validating provided URL...</span>
      )}
      <QueryResult status={queryStatus}>
        <KeyValueList
          list={{
            "Estimated file size": fileSize
              ? humanReadableBytes(fileSize)
              : "Unknown",
            ...(hasSufficientCapacity && fileSize
              ? {
                  "Estimated remaining analysis capacity after import":
                    humanReadableBytes(remainingAfterImport),
                }
              : {}),
          }}
        />
        <div className={styles["file-size-errors"]}>
          {isOverSizeLimit && fileSize && (
            <div>
              <Callout type="error" title="Size limit exceeded">
                <span>
                  Selected file (
                  <strong>{humanReadableBytes(fileSize, 2)}</strong>) exceeds
                  upload limit (
                  <strong>{humanReadableBytes(uploadLimit, 2)}</strong>
                  ).
                </span>
              </Callout>
            </div>
          )}
          {!hasSufficientCapacity && fileSize && (
            <div>
              <Callout type="error" title="Insufficient capacity">
                <span>
                  Selected file (
                  <strong>{humanReadableBytes(fileSize, 2)}</strong>) is larger
                  than remaining analysis capacity (
                  <strong>{humanReadableBytes(remainingQuota, 2)}</strong>)
                </span>
              </Callout>
            </div>
          )}
        </div>
      </QueryResult>
    </div>
  );
};

export default UrlImportUsage;
